import { InjectionKey, Ref } from "@vue/composition-api";

export const EmailKey: InjectionKey<Ref<string>> = Symbol();
